/**
 * Klivlo - La couverture de Noël à colorier (prefix ccb-), handoff v2.
 *
 * Prices are never hardcoded here: they come from the variants printed by
 * the buy box (#ccb-data). A pack of N = N x the chosen variant; Shopify's
 * automatic discounts charge the pack price, taking the percentage off each
 * blanket rounded DOWN to the cent - packPrice() does exactly the same, so
 * the page always equals /cart.js.
 *
 * The free markers are their own 0,00 product added next to the blankets
 * (one set per pack, never more sets than blankets). The cart drawer is
 * drawn from the real cart.
 */
var dataEl = document.getElementById('ccb-data');
var DATA = dataEl ? JSON.parse(dataEl.textContent) : null;

function $(sel, root) { return (root || document).querySelector(sel); }
function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

// The visitor's language + country ("de-AT", "en-US", "es-MX"...), so the
// script prints prices the way ccb-money.liquid and the checkout do.
var fmt;
try { fmt = new Intl.NumberFormat((DATA && DATA.locale) || 'fr-FR', { style: 'currency', currency: (DATA && DATA.currency) || 'EUR' }); }
catch (e) { fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (DATA && DATA.currency) || 'EUR' }); }
function money(cents) { return fmt.format((Number(cents) || 0) / 100); }

// Theme cart events (header badge, other listeners). Optional: the page
// works without them.
var Events = null;
import('@shopify/events').then(function (m) { Events = m; }).catch(function () {});
function announce(action, lines, cart) {
  if (!Events || !Events.CartLinesUpdateEvent) return;
  try {
    var E = Events.CartLinesUpdateEvent;
    var d = E.createPromise();
    document.dispatchEvent(new E({ action: action, context: 'product', lines: lines, promise: d.promise }));
    d.resolve({ cart: E.createCartFromAjaxResponse(cart), detail: { didError: false, source: 'ccb' } });
  } catch (e) {}
}

/* ---------------- Accordions (buy box + FAQ) ---------------- */
$$('[data-ccb-accs]').forEach(function (group) {
  var single = group.hasAttribute('data-single');
  $$('.ccb-acc-btn', group).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (single) $$('.ccb-acc-btn', group).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });
});

/* ---------------- Header nav: drop links to sections not on the page ---------------- */
$$('[data-ccb-navlink]').forEach(function (a) {
  var h = a.getAttribute('href') || '';
  if (h.charAt(0) === '#' && h.length > 1 && !document.getElementById(h.slice(1))) a.hidden = true;
});

var cartApi = {
  root: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/',
  get: function () { return fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
  post: function (path, body) {
    return fetch(this.root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (j) {
        if (!res.ok) throw new Error(j.description || j.message || 'cart error');
        return j;
      });
    });
  },
};

var drawerApi = initDrawer();
if (DATA) initBuy();

/* ================================================================ */
function initBuy() {
  var variants = DATA.variants;
  var current = variants.filter(function (v) { return v.id === DATA.selected; })[0] || variants[0];
  var state = { tier: Number(DATA.defaultTier) || 1, qty: 1, set: true, priority: false };

  function packPrice(v, n) {
    var pct = Number(DATA.packPct[String(n)]) || 0;
    var each = v.price - Math.floor(v.price * pct / 100);
    return each * n;
  }
  function compareOf(v) { return v.compare > v.price ? v.compare : v.price; }

  /* ---------- Options ---------- */
  $$('[data-ccb-opt]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var i = Number(btn.getAttribute('data-ccb-opt')) - 1;
      selectOption(i, btn.getAttribute('data-value'));
    });
  });
  function selectOption(i, value) {
    var wanted = current.options.slice();
    wanted[i] = value;
    var match = variants.filter(function (v) { return v.options.join('|') === wanted.join('|'); })[0];
    if (!match) match = variants.filter(function (v) { return v.options[i] === value; })[0];
    if (!match) return;
    current = match;
    render(true);
  }

  /* ---------- Gallery ---------- */
  var slides = $$('.ccb-stage .ccb-slide');
  var thumbs = $$('[data-ccb-thumb]');
  function showMedia(id) {
    var idx = DATA.media.indexOf(Number(id));
    if (idx < 0) return;
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
    if (thumbs[idx] && thumbs[idx].parentNode.scrollWidth > thumbs[idx].parentNode.clientWidth) {
      thumbs[idx].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var id = Number(t.getAttribute('data-ccb-thumb'));
      var owner = variants.filter(function (v) { return v.media === id; })[0];
      if (owner && DATA.imgOpt) {
        selectOption(DATA.imgOpt - 1, owner.options[DATA.imgOpt - 1]);
      }
      showMedia(id);
    });
  });

  /* ---------- Packs ---------- */
  var packs = $$('[data-ccb-pack]');
  packs.forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-ccb-toggle]')) return;
      state.tier = Number(el.getAttribute('data-ccb-pack'));
      render(false);
    });
    el.addEventListener('keydown', function (e) {
      if (e.target !== el) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var n = state.tier + (e.key === 'ArrowDown' ? 1 : -1);
        if (n >= 1 && n <= packs.length) { state.tier = n; render(false); packs[n - 1].focus(); }
      }
    });
  });

  /* ---------- Add-on toggles (one state, a copy in every pack) ---------- */
  $$('[data-ccb-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-ccb-toggle');
      state[k] = !state[k];
      render(false);
    });
  });

  /* ---------- Quantity ---------- */
  $$('[data-ccb-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.qty = Math.min(9, Math.max(1, state.qty + Number(b.getAttribute('data-ccb-qty'))));
      render(false);
    });
  });

  function render(variantChanged) {
    var cmp = compareOf(current);
    var hasCmp = cmp > current.price;
    $$('[data-ccb-unit-price]').forEach(function (el) { el.textContent = money(current.price); });
    $$('[data-ccb-unit-compare]').forEach(function (el) { el.textContent = money(cmp); el.hidden = !hasCmp; });
    $$('[data-ccb-unit-save]').forEach(function (el) { el.hidden = !hasCmp; });
    $$('[data-ccb-unit-pct]').forEach(function (el) { el.textContent = Math.round((cmp - current.price) * 100 / cmp); });

    packs.forEach(function (el) {
      var n = Number(el.getAttribute('data-ccb-pack'));
      var pp = packPrice(current, n);
      var pc = cmp * n;
      var save = pc - pp;
      el.classList.toggle('is-selected', n === state.tier);
      el.setAttribute('aria-checked', n === state.tier ? 'true' : 'false');
      $('[data-ccb-pack-price]', el).textContent = money(pp);
      $('[data-ccb-pack-compare]', el).textContent = money(pc);
      $('[data-ccb-pack-save]', el).textContent = money(save);
      $('[data-ccb-pack-pct]', el).textContent = pc ? Math.round(save * 100 / pc) : 0;
      $('[data-ccb-pack-compare]', el).hidden = save <= 0;
      $('.ccb-pack-save', el).hidden = save <= 0;
      $('.ccb-pack-badge', el).hidden = save <= 0;
    });

    $$('[data-ccb-toggle]').forEach(function (b) {
      b.setAttribute('aria-checked', state[b.getAttribute('data-ccb-toggle')] ? 'true' : 'false');
    });
    $$('[data-ccb-qty-value]').forEach(function (el) { el.textContent = state.qty; });

    $$('[data-ccb-opt]').forEach(function (b) {
      var i = Number(b.getAttribute('data-ccb-opt')) - 1;
      b.setAttribute('aria-pressed', current.options[i] === b.getAttribute('data-value') ? 'true' : 'false');
    });
    $$('[data-ccb-opt-label]').forEach(function (el) {
      var i = Number(el.getAttribute('data-ccb-opt-label'));
      el.textContent = current.options[i - 1] + (i === DATA.sizeOpt ? DATA.sizeSuffix : '');
    });

    $$('[data-ccb-add]').forEach(function (b) {
      b.disabled = !current.available;
      if (!b.dataset.label) b.dataset.label = b.textContent;
      b.textContent = current.available ? b.dataset.label : DATA.text.unavailable;
    });

    if (variantChanged) {
      if (current.media) showMedia(current.media);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {}
    }
  }
  render(false);

  /* ---------- Add to cart ---------- */
  function addToCart(e) {
    var btn = e.currentTarget;
    if (!current.available) return;
    var items = [{ id: current.id, quantity: state.tier * state.qty }];
    if (state.set && DATA.setVariantId) items.push({ id: DATA.setVariantId, quantity: state.qty });
    if (state.priority && DATA.priorityVariantId) items.push({ id: DATA.priorityVariantId, quantity: 1 });

    var buttons = $$('[data-ccb-add]');
    buttons.forEach(function (b) { b.disabled = true; });
    cartApi.post('cart/add.js', { items: items })
      .then(function () { return cartApi.get(); })
      .then(function (cart) { return drawerApi.fixGifts(cart); })
      .then(function (cart) {
        announce('add', items.map(function (i) { return { merchandiseId: i.id, quantity: i.quantity }; }), cart);
        drawerApi.resetReserve();
        drawerApi.draw(cart);
        drawerApi.open(btn);
        var label = btn.dataset.label || btn.textContent;
        btn.textContent = DATA.text.added;
        setTimeout(function () { btn.textContent = label; }, 1800);
      })
      .catch(function (err) {
        console.error('[ccb] add to cart failed', err);
        alert(DATA.text.error);
      })
      .finally(function () { buttons.forEach(function (b) { b.disabled = !current.available; }); });
  }
  $$('[data-ccb-add]').forEach(function (b) { b.addEventListener('click', addToCart); });
}

/* ================================================================ */
function initDrawer() {
  var drawer = $('[data-ccb-drawer]');
  var noop = { draw: function () {}, open: function () {}, resetReserve: function () {}, fixGifts: function (c) { return Promise.resolve(c); } };
  if (!drawer) return noop;
  var panel = $('.ccb-panel', drawer);
  var linesEl = $('[data-ccb-lines]', drawer);
  var tpl = $('[data-ccb-line-tpl]', drawer);
  var giftMeta = drawer.getAttribute('data-gift-meta') || '';
  var lastFocus = null;
  var closeTimer = null;

  var compareById = {};
  if (DATA) {
    DATA.variants.forEach(function (v) { compareById[v.id] = v.compare; });
    if (DATA.setVariantId) compareById[DATA.setVariantId] = DATA.setCompare;
  }

  function open(from) {
    clearTimeout(closeTimer);
    lastFocus = from || document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('ccb-lock');
    tick();
    panel.focus({ preventScroll: true });
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ccb-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  // The free markers never outnumber the blankets; with no blanket left
  // they leave the cart too.
  function fixGifts(cart) {
    if (!DATA || !DATA.setVariantId) return Promise.resolve(cart);
    var blankets = 0, setLine = null;
    cart.items.forEach(function (it) {
      if (it.product_id === DATA.productId) blankets += it.quantity;
      if (it.variant_id === DATA.setVariantId) setLine = it;
    });
    if (!setLine || setLine.quantity <= blankets) return Promise.resolve(cart);
    return cartApi.post('cart/change.js', { id: setLine.key, quantity: blankets });
  }

  function draw(cart) {
    var has = cart.item_count > 0;
    $$('[data-ccb-when-items]', drawer).forEach(function (el) { el.hidden = !has; });
    $('[data-ccb-empty]', drawer).hidden = has;
    $('[data-ccb-subtotal]', drawer).textContent = money(cart.total_price);
    $$('[data-ccb-count]').forEach(function (el) { el.textContent = cart.item_count; });

    var saved = 0;
    linesEl.innerHTML = '';
    cart.items.forEach(function (it) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var img = $('img', node);
      if (it.image) { img.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=168'; }
      else { img.remove(); }
      $('[data-f="name"]', node).textContent = it.product_title.replace(/\s*\([^)]*\)\s*$/, '');
      var meta = it.product_has_only_default_variant ? '' : (it.variant_title || '');
      if (it.final_line_price === 0 && giftMeta) meta = giftMeta;
      $('[data-f="meta"]', node).textContent = meta;
      $('[data-f="qty"]', node).textContent = it.quantity;
      $('[data-f="total"]', node).textContent = money(it.final_line_price);
      var cmp = (compareById[it.variant_id] || 0) * it.quantity;
      var was = $('[data-f="was"]', node);
      if (cmp > it.final_line_price) { was.textContent = money(cmp); saved += cmp - it.final_line_price; }
      else { was.remove(); }
      $$('[data-ccb-change]', node).forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.getAttribute('data-ccb-change');
          var q = d === 'remove' ? 0 : Math.max(1, it.quantity + Number(d));
          if (q !== it.quantity) change(it.key, q);
        });
      });
      linesEl.appendChild(node);
    });
    var savedWrap = $('[data-ccb-saved-wrap]', drawer);
    if (savedWrap) {
      savedWrap.hidden = saved <= 0;
      $('[data-ccb-saved]', drawer).textContent = money(saved);
    }
    if (!has) clearReserve();
  }

  function change(key, quantity) {
    drawer.classList.add('is-busy');
    cartApi.post('cart/change.js', { id: key, quantity: quantity })
      .then(fixGifts)
      .then(function (cart) {
        announce(quantity === 0 ? 'remove' : 'update', [{ id: key, quantity: quantity }], cart);
        draw(cart);
      })
      .catch(function (err) { console.error('[ccb] cart change failed', err); })
      .finally(function () { drawer.classList.remove('is-busy'); });
  }

  $$('[data-ccb-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('button, a[href], [tabindex]:not([tabindex="-1"])', panel).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && (document.activeElement === f[0] || document.activeElement === panel)) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  // Header "Panier" and any theme cart link open this drawer: one cart UI per page.
  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ccb-open-cart], [data-testid="cart-drawer-trigger"], a[href$="/cart"]');
    if (!t || drawer.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    cartApi.get().then(fixGifts).then(function (cart) { draw(cart); open(t); });
  }, true);

  /* Reservation countdown: restarts on every add, kept in sessionStorage,
     an expired value restarts instead of freezing at 0:00 (04-traps C5). */
  var KEY = 'ccb-cart-deadline';
  var WINDOW = ((DATA && DATA.reserveMinutes) || 5) * 60 * 1000;
  function resetReserve() { try { sessionStorage.setItem(KEY, String(Date.now() + WINDOW)); } catch (e) {} }
  function clearReserve() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function tick() {
    var until = 0;
    try { until = Number(sessionStorage.getItem(KEY)); } catch (e) {}
    if (!until || isNaN(until) || until <= Date.now() || until > Date.now() + WINDOW) { resetReserve(); until = Date.now() + WINDOW; }
    var left = Math.max(0, Math.round((until - Date.now()) / 1000));
    $$('[data-ccb-reserve-timer]', drawer).forEach(function (el) { el.textContent = Math.floor(left / 60) + ':' + String(left % 60).padStart(2, '0'); });
  }
  setInterval(function () { if (drawer.classList.contains('is-open')) tick(); }, 1000);

  cartApi.get().then(fixGifts).then(draw).catch(function () {});
  return { draw: draw, open: open, resetReserve: resetReserve, fixGifts: fixGifts };
}
